/**
 * 图片尺寸
 */

import './image.css';
import React, {Component} from 'react';

// devicePixelRatio
const DPR = window.devicePixelRatio ? window.devicePixelRatio : 1;

// 图片后缀正则
const REG_IMG_EXT = /.(jpg|png|gif|jpeg)/i;

// 图片url正则
const REG_IMG_SRC = /^(?:(?:http|https):)?\/\/(.+\.((?:upcdn|cdn))\.((?:pengpengla|upliveapp|upliveapps))\.(?:com))(\/.*(?:\.(jpg|png|gif|jpeg|webp))?)$/i;

const IMG_DEFAULT_SRC = '//g.cdn.pengpengla.com/oauthgame/html5/20170606/0c0688e97bf70219860dc285cf8a3fdc.png';

const IMG_PLACEHOLDE = "//g.cdn.pengpengla.com/oauthgame/html5/20181014/484a481c33c891be09c2a5c34bc08b2d.jpg";
// 海外CDN图片尺寸的大小列表
const IMG_SIZE_LIST = [50, 80, 100, 300];
// const IMG_SIZE_LIST = [50, 80, 100];

const getNewImageUrl = function(url, size) {
        let newUrl; 

        size = size || 300;
        
        url = url.replace('p-cdn.upliveapp.com', 'p.cdn.upliveapp.com');
        
        if (url.match(REG_IMG_SRC)) {
            
            let cdnSize = url.match(REG_IMG_SRC);
            
            if (cdnSize[2] == 'upcdn' || cdnSize[3] == 'upliveapp' || cdnSize[3] == 'upliveapps') {
                // 海外头像
                let exts = url.match(REG_IMG_EXT);
                
                if (exts) {
                    let ext = '_' + size + '_' + size + exts[0];
                    newUrl = url.replace(REG_IMG_EXT, ext);
                } else {
                    // console.log('图片后缀名错误');
                }
            } else {
                newUrl = url +'?imageView2/1/w/'+ size +'/h/' + size;
            }
        } else {
            newUrl = url;
        }
        // TODO 用正则处理
        newUrl = newUrl.replace('http://p.cdn.upliveapp.com', 'https://p-cdn.upliveapp.com');
        newUrl = newUrl.replace('http://p.cdn.upliveapps.com', 'https://p-cdn.upliveapp.com');
        newUrl = newUrl.replace('http://p.upcdn.pengpengla.com', 'https://p.upcdn.pengpengla.com');

        return  newUrl;
    }

class Image extends Component{
    static defaultProps = {
        lazyload: false,
        src: '', // 图片地址
        cssmode: 640,
        type: 'square', // 图片类型，默认square: 正方形，custom: 裁剪称任意类型，只有七牛图片才支持
        size: '',
        width: '', // 图片宽度
        height: '', // 图片高度
        circle: false, // 圆形
        rounded: false, // 椭圆
        bordered: false
    }
    constructor(props){
        super(props);
        this.state = {
            src: props.src,
            isVisible: props.isVisible
        }
        this.loaded = false;
    }
    
    componentWillReceiveProps(nextProps) {
        let isVisible = this.state.isVisible  ||  nextProps.isVisible;
        
        this.setState({
            src: nextProps.src,
            isVisible: isVisible
        });
    } 

    onLoad=(e)=>{
        var img = this.refs.img;
        
        if (img) {
            var node = $(img);
            
            img.style.opacity = "1";
            img.onload = img.onerror = null;
            this.timer = setTimeout(() =>{
                this.timer && clearTimeout(this.timer);
                node.removeClass("ui-fade");
            }, 700);
            this.loaded = true;
        }
    }
    /**
     * 输出转换后的图片url
     * @param {string} src 图片url
     */
    getNewUrl(url) {
        let width = this.props.width || this.props.size;
        let height = this.props.height || this.props.size;
        let defaultSize = this.props.size || this.props.width;
        let newUrl;

        url = url.replace('p-cdn.upliveapp.com', 'p.cdn.upliveapp.com');

        if (url.match(REG_IMG_SRC)) {
            
            let cdnSize = url.match(REG_IMG_SRC);
            
            if (this.props.type == 'square') {

                if (cdnSize[2] == 'upcdn' || cdnSize[3] == 'upliveapp' || cdnSize[3] == 'upliveapps') {
                    // 海外头像
                    let size = this.props.imageSize || this.getBestCdnSize(defaultSize); // 头像 width == height
                    let exts = url.match(REG_IMG_EXT);
                    
                    if (exts) {
                        let ext = '_' + size + '_' + size + exts[0];
                        newUrl = url.replace(REG_IMG_EXT, ext);
                    } else {
                        // console.log('图片后缀名错误');
                    }
                } else {
                    newUrl = this.state.src +'?imageView2/1/w/'+ width +'/h/' + height;
                }
            } else {
                newUrl = this.state.src +'?imageView2/1/w/'+ width +'/h/' + height;
            }
        } else {
            newUrl = url;
        }

        // TODO 用正则处理
        newUrl = newUrl.replace('http://p.cdn.upliveapp.com', 'https://p-cdn.upliveapp.com');
        newUrl = newUrl.replace('http://p.cdn.upliveapps.com', 'https://p-cdn.upliveapp.com');
        newUrl = newUrl.replace('http://p.upcdn.pengpengla.com', 'https://p.upcdn.pengpengla.com');

        return  newUrl;
    }
    /**
     * 获取海外头像图片最佳尺寸
     * @param  {number| string} curSize 图片尺寸
     */
    getBestCdnSize(curSize) {
        if (!curSize || typeof curSize != 'string' && typeof curSize != 'number') {
            // console.log('未设置图片尺寸');
        }
        let sizeList = IMG_SIZE_LIST;
        let max = sizeList[sizeList.length - 1];
        let min = sizeList[0];
        let bestSize = 0;

        if (max <= curSize) {
            return max;
        }
        if (min >= curSize) {
            return min;
        }

        for (let i = sizeList.length; i >= 0; i--) {
            if (sizeList[i] <= curSize) {
                if (sizeList[i] == curSize) {
                    bestSize = curSize;
                } else {
                    if (i < sizeList.length - 1) {
                        // 取最近最优的尺寸
                        bestSize = sizeList[i + 1]
                    }
                }
                break;
            }
        }

        return bestSize;
    }
    render() {
        let width = this.props.width || this.props.size;
        let height = this.props.height || this.props.size;
        let cls = 'ui-img';
        let style = {};
        let props;

        cls += this.props.bordered ? ' ui-bordered': '';
        cls += this.props.circle ? ' ui-circle': '';
        cls += this.props.rounded ? ' ui-rounded': '';
        
        style = {
            width: width,
            height: height
        }

        if (this.props.lazyload) {
            if (this.state.isVisible) {
                props = {
                    src: this.state.src ? this.getNewUrl(this.state.src): IMG_PLACEHOLDE
                };

                return (
                    <span className={cls} style={style} data-width={width} data-source={this.state.src} data-height={height}>
                        <img ref="img" {...props} alt=""/>
                    </span>
                );
            } else {
                props = {
                    'data-src': this.state.src ? this.getNewUrl(this.state.src): '',
                    src: IMG_PLACEHOLDE
                };

                return (
                    <span className={cls} style={style} data-width={width} data-height={height}>
                        <img ref="img" {...props}/>
                    </span>
                );
            }
        } else {
            props = {
                src: this.state.src ? this.getNewUrl(this.state.src): IMG_PLACEHOLDE
            };
            return (
                <span className={cls} style={style} data-width={width} data-source={this.state.src} data-height={height}>
                    <img ref="img" {...props} onLoad={this.onLoad} alt=""/>
                </span>
            );
        }
    }
}

export default Image;

export {
    getNewImageUrl
}



// WEBPACK FOOTER //
// ./js/component/user-ui/Image.js